export const countries = [
  { code: 'BR', name: 'Brasil' },
  { code: 'PT', name: 'Portugal' },
  { code: 'US', name: 'Estados Unidos' },
  { code: 'ES', name: 'Espanha' },
  { code: 'FR', name: 'França' },
  { code: 'IT', name: 'Itália' },
  { code: 'DE', name: 'Alemanha' },
  { code: 'GB', name: 'Reino Unido' },
  { code: 'CA', name: 'Canadá' },
  { code: 'AR', name: 'Argentina' },
  { code: 'UY', name: 'Uruguai' },
  { code: 'CL', name: 'Chile' },
  { code: 'PY', name: 'Paraguai' },
  { code: 'PE', name: 'Peru' },
  { code: 'CO', name: 'Colômbia' },
  { code: 'VE', name: 'Venezuela' },
  { code: 'MX', name: 'México' },
  { code: 'AU', name: 'Austrália' },
  { code: 'NZ', name: 'Nova Zelândia' },
  { code: 'JP', name: 'Japão' },
  { code: 'CN', name: 'China' },
  { code: 'KR', name: 'Coreia do Sul' },
  { code: 'IN', name: 'Índia' },
  { code: 'RU', name: 'Rússia' },
  { code: 'ZA', name: 'África do Sul' },
  { code: 'EG', name: 'Egito' },
  { code: 'MA', name: 'Marrocos' },
  { code: 'NG', name: 'Nigéria' },
  { code: 'KE', name: 'Quênia' },
  { code: 'IL', name: 'Israel' },
  { code: 'SA', name: 'Arábia Saudita' },
  { code: 'AE', name: 'Emirados Árabes Unidos' },
  { code: 'TR', name: 'Turquia' },
  { code: 'PL', name: 'Polônia' },
  { code: 'SE', name: 'Suécia' },
  { code: 'NO', name: 'Noruega' },
  { code: 'FI', name: 'Finlândia' },
  { code: 'DK', name: 'Dinamarca' },
  { code: 'IE', name: 'Irlanda' },
  { code: 'NL', name: 'Países Baixos' },
  { code: 'BE', name: 'Bélgica' },
  { code: 'CH', name: 'Suíça' },
  { code: 'AT', name: 'Áustria' },
  { code: 'GR', name: 'Grécia' },
  // ... adicione mais países conforme necessário
]; 